import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NEVER, Observable} from 'rxjs';
import {ConfigurationService} from '../conf/configuration.service';
import {LogService} from '../log/log.service';
import {Session} from '../session/session.models';
import {SessionService} from '../session/session.service';
import {noop} from '../utils/misc.util';

@Injectable()
export class DefaultHeadersApiPreInterceptor implements HttpInterceptor {
	public static CONTENT_TYPE_HEADER: string = 'Content-Type';
	public static AUTHORIZATION_HEADER: string = 'Authorization';
	private readonly CONTENT_TYPE_APPLICATION_JSON: string = 'application/json';
	private session: Session;

	constructor(
		private logService: LogService,
		private conf: ConfigurationService,
		private router: Router,
		private sessionService: SessionService
	) {
		this.sessionService.session$.subscribe(session => {
			if (session) {
				this.session = session;
			} else {
				this.session = null;
			}
		});
	}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		if (req.url.startsWith(this.conf.getAsString('api.baseHref'))) {

			let newHeaders = req.headers;

			if (!req.url.startsWith(this.conf.getAsString('api.baseHref').concat('/backoffice/model-lists')) && !req.url.endsWith('import')) {
				newHeaders = req.headers.append(
					DefaultHeadersApiPreInterceptor.CONTENT_TYPE_HEADER,
					this.CONTENT_TYPE_APPLICATION_JSON
				);
			}

			if (this.session) {
				if (!this.sessionService.isTokenValid()) {
					this.logService.error(
						'jwt invalid, logout and redirect to username'
					);
					this.sessionService.logout();
					this.router.navigate(['/login']).then(noop);

					return NEVER;
				}
				newHeaders = newHeaders.append(
					DefaultHeadersApiPreInterceptor.AUTHORIZATION_HEADER,
					this.session.token
				);
			}

			const duplicate = req.clone({
				headers: newHeaders
			});
			return next.handle(duplicate);
		} else {
			return next.handle(req);
		}
	}
}
